import React from 'react';
import leftArrow from './icons/leftArrow.png';
import rightArrow from './icons/rightArrow.png';
import { Avatar } from './Avatar';
import { DisplayAvatar } from './DisplayAvatar';

export const EditDisplayAvatar = ({ hideArrows, selected, counter, setCounter, toPickFrom, listOfColors, colorStyleID, props: [avatarStyleProps, setAvatarStyleProps, avatarColorProps, setAvatarColorProps] }) => {
    function handleArrows(e) {
        if (counter <= 0) {
            setCounter(counter + 1);
        } else if (counter === toPickFrom.length - 1) {
            setCounter(counter - 1);
        } else {
            const target = e.target.id;
            if (target === 'right') {
                setCounter(counter + 1);
            } else {
                setCounter(counter - 1);
            }
        }
        setAvatarColorProps(avatarColorProps);
        setAvatarStyleProps(avatarStyleProps);
    }

    return (
        <>
            {selected
                ? counter === 0
                    ? <>
                        <div className='edit-avatar relative md:w-baseAvatarCont md:h-baseAvatarFrame sm:w-baseAvatarCont sm:h-baseAvatarFrame xs:w-xsAvatarCont xs:h-xsAvatarFrame'>
                            <DisplayAvatar
                                colorStyleID={colorStyleID}
                                listOfColors={listOfColors}
                                avatarColorProps={avatarColorProps}
                                setAvatarColorProps={setAvatarColorProps}
                                edit={colorStyleID !== -1}
                                selected={selected}
                                avatar={
                                    <Avatar
                                        {...avatarStyleProps} {...avatarColorProps}>
                                    </Avatar>}
                            />
                            {!hideArrows && <div className='d-container-arrows absolute bottom-0 flex right-0 justify-end'>
                                <img id='right' className='w-12 h-12 cursor-pointer mr-[0.2rem]'
                                    src={rightArrow} onClick={(e) => { handleArrows(e); }}>
                                </img>
                            </div>
                            }
                        </div>
                    </>
                    : counter === toPickFrom.length - 1
                        ? <>
                            <div className='edit-avatar relative xs:w-xsAvatarCont xs:h-xsAvatarFrame
                            sm:w-baseAvatarCont sm:h-baseAvatarFrame
                            md:w-baseAvatarCont md:h-baseAvatarFrame'>
                                <DisplayAvatar
                                    colorStyleID={colorStyleID}
                                    listOfColors={listOfColors}
                                    avatarColorProps={avatarColorProps}
                                    setAvatarColorProps={setAvatarColorProps}
                                    edit={colorStyleID !== -1}
                                    selected={selected}
                                    avatar={
                                        <Avatar
                                            {...avatarStyleProps} {...avatarColorProps}>
                                        </Avatar>}
                                />
                                {!hideArrows
                                    && <div className='d-container-arrows absolute bottom-0 left-0'>
                                        <img id='left' className='w-12 h-12 cursor-pointer ml-[0.2rem]' src={ leftArrow } onClick={(e) => { handleArrows(e); }}></img>
                                    </div>
                                }
                            </div>
                        </>
                        : <>
                            <div className='edit-avatar relative xs:w-xsAvatarCont xs:h-xsAvatarFrame
                            w-baseAvatarCont h-baseAvatarFrame
                            md:w-baseAvatarCont md:h-baseAvatarFrame
                            '>
                                <DisplayAvatar
                                    colorStyleID={colorStyleID}
                                    listOfColors={listOfColors}
                                    avatarColorProps={avatarColorProps}
                                    setAvatarColorProps={setAvatarColorProps}
                                    edit={colorStyleID !== -1}
                                    selected={selected}
                                    avatar={
                                        <Avatar
                                            {...avatarStyleProps} {...avatarColorProps}>
                                        </Avatar>}
                                />
                                {!hideArrows && <div className='d-container-arrows relative bottom-12 flex  w-full justify-between'>
                                    <div>
                                        <img id='left' className='w-12 h-12 cursor-pointer'
                                            src={leftArrow} onClick={(e) => { handleArrows(e); }}>
                                        </img>
                                    </div>
                                    <div>
                                        <img id='right' className='w-12 h-12 cursor-pointer'
                                            src={rightArrow} onClick={(e) => { handleArrows(e); }}>
                                        </img>
                                    </div>
                                </div>
                                }
                            </div>
                        </>
                : <div className='original-avatar'>
                    <DisplayAvatar avatar={<Avatar {...avatarStyleProps}
                        {...avatarColorProps}></Avatar>} />
                </div>
            }
        </>
    );
};
